import React from 'react';
import {Calendar, CalendarDisabled} from './assets/Calendar';
import {AlertIcon} from './assets/Alert';

export interface IconProps {
  name: string;
  additionalProps?: {};
}

export interface IconInterface {
  [key: string]: any;
}

const icons: IconInterface = {
  calendar: <Calendar />,
  calendarDisabled: <CalendarDisabled />,
  alertIcon: <AlertIcon />,
  };

export const Icon = (props: IconProps) => {
  return React.cloneElement(icons[props.name], {...{ariaHidden: true}, ...props.additionalProps});
};
